// extracted by mini-css-extract-plugin
export var closeButton = "_l2-1";
export var closeX = "_l2-3";
export var container = "_l2-0";
export var image = "_l2-2";